module.exports = __webpack_public_path__ + "static/media/exonmobil.02e7f218.svg";